import { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Link,
  Paper,
  Snackbar,
  TextField,
} from "@mui/material";
import Loader from "../../components/loader/loader";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import logo from "../../assets/escudo.png";
import { useAuth } from "../../services/auth/AuthContext";
import { FORGOT_PASSWORD, SINGUP } from "../../utils/app-routes";
import PasswordField from "../../components/password-field/password-field";

export default function Login() {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [snackBarOpen, setSAnackBarOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleLogin = async () => {
    setIsLoading(true);

    try {
      signIn(username, password).then(
        (response) => {
          setIsLoading(false);
          window.location.href = "/";
        },
        () => {
          setIsLoading(false);
          handleOpenSnackBar();
        }
      );
    } catch (err) {
      setIsLoading(false);
      handleOpenSnackBar();
    }
  };

  const handleCloseSnackBar = () => {
    setSAnackBarOpen(false);
  };

  const handleOpenSnackBar = () => {
    setSAnackBarOpen(true);
  };

  const snackBar = () => {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={snackBarOpen}
        onClose={handleCloseSnackBar}
        message="Usuario o contraseña inválidos"
        autoHideDuration={1200}
        key="snackbar-login"
      />
    );
  };

  return (
    <div
      className={`login_bg flex items-center justify-center w-full h-screen `}
    >
      {/* <div className={`${styles.login_bg} w-1/2 h-full `}></div> */}
      <div className={`login_protector`}></div>
      <Paper
        className={`login_container flex flex-col  lg:w-1/3  md:w-2/3 w-2/3 p-5`}
      >
        {/* <Avatar
          sx={{ width: "200px", height: "200px" }}
          alt="Logo Esparza"
          src={logo}
          className={`logo_container`}
        /> */}
        <Box
          sx={{
            width: 150, // ajusta al diseño
            height: 150,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 2,
            bgcolor: "transparent",
          }}
          className="flex-shrink-0 self-center"
        >
          <img
            src={logo}
            alt="Logo Esparza"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>

        <h1 className="mb-5 mt-20">
          <strong>Bienvenido(a)</strong>
        </h1>
        <TextField
          value={username}
          onChange={(event) => setUsername(event.target.value)}
          label="Correo electrónico"
          variant="filled"
        />
        <br />
        <PasswordField
          id="1"
          value={password}
          onChange={setPassword}
          label="Contraseña"
        />

        <Link href={FORGOT_PASSWORD} variant="body2">
          ¿Olvidaste tu contraseña?
        </Link>

        {isLoading ? (
          <div className="mt-5">
            <Loader />
          </div>
        ) : (
          <div className="flex flex-col">
            <Button
              onClick={() => handleLogin()}
              className={`basic_margin w-full`}
              variant="contained"
            >
              Iniciar sesión
            </Button>
            <Divider className="w-full margin">¿No tienes una cuenta?</Divider>

            <Button className="margin" href={SINGUP}>
              Registrate
            </Button>
          </div>
        )}
      </Paper>
      {snackBar()}
    </div>
  );
}
